var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({staticClass:"font-weight-bold"},'v-chip',_vm.chipProps,false),_vm.$listeners),[_c('span',{class:{ strike: _vm.strike }},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }